export const LANGUAGES = {
  JA: "ja",
  EN: "en",
  TW: "tw",
}

export const RECAPTCHA_LANGUAGES = {
  JA: "ja",
  EN: "en",
  TW: "zh-TW",
}

export const DAYJS_LOCALES = {
  JA: "ja",
  EN: "en",
  TW: "zh-tw",
}

export const DATEPICKER_LOCALES = {
  JA: "ja",
  EN: "en",
  TW: "zhTW",
}